<template>
    <div id="top-menu">
        <div class="navbar-logo-lite">
            <SVGNavbarLogo class="logo-lite-svg"/>
        </div>
        <div>
          <router-view name="lowerBarLeft"></router-view>
        </div>
        <router-link to="/configurator/projects" class="line-nav-option" title="Авторизация">
            {{userName}}
        </router-link>
        <div class="line-nav-option" v-on:click="showModal('modal-feedback')" title="Помощь">
            Помощь
        </div>
    </div>
</template>

<script>
    import SVGNavbarLogo from "../SVG/SVGNavbarLogo.vue";
    import SVGNavbarUser from "../SVG/SVGNavbarUser.vue";
    import SVGDialog from "../SVG/SVGDialog";
    import {modalMethods} from "../common";

    export default {
        name: "TheLiteNavbar",
        mixins: [modalMethods],
        components: {
            SVGDialog,
            SVGNavbarUser,
            SVGNavbarLogo
        },
        computed:{
            userName(){
                const name = this.$store.state.profile.userName;
                if(name){
                    return name;
                } else {
                    return 'Авторизация';
                }
            }
        }
    }
</script>

<style scoped>
    #top-menu {
        display: grid;
        grid-template-columns: max-content auto max-content max-content;
        width: 100%;
        height: 80px;
        background-color: white;
        /*border-bottom: 2px solid #F2F2F2;*/
        border-bottom: 1px solid #ededed;
        z-index: 11;
        position: relative;
    }

    .navbar-logo-lite {
        user-select: none;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
    }

    .logo-lite-svg {
        width: 180px;
        height: 34px;
    }

    #navbar-logo-container {
        display: block;
        margin: 15px 30px;
    }

    #dialog-svg-container {
        padding: 7px 0;
        cursor: pointer;
        color: #BDBDBD;
        text-align: right;
        margin: 15px 30px 15px 0;
        width: max-content;
    }

    #dialog-svg-container:hover {
        color: #A3A3A3;
    }

    #dialog-svg-container:active {
        color: #BDBDBD;
    }

    #navbar-user-container {
        display: grid;
        grid-template-columns: auto 40px;
        margin: 15px 30px;
        text-align: right;
    }

    .user-text-container {
        padding: 14px 0;
        color: #BDBDBD;
        user-select: none;
    }

    #user-svg-container {
        padding: 7px 0;
        cursor: pointer;
        color: #BDBDBD;
    }

    #user-svg-container:hover {
        color: #A3A3A3;
    }

    #user-svg-container:active {
        color: #BDBDBD;
    }

    .func-buttons {
      margin-top: 8px;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltip-text {
        visibility: hidden;
        width: 120px;
        background-color: #626262;
        color: #fff;
        text-align: center;
        /*border-radius: 6px;*/
        padding: 5px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
        top: 100%;
        left: -25%;
        margin-left: -60px;
    }

    .tooltip:hover .tooltip-text {
        visibility: visible;
    }

    .tooltip-text::after {
        content: "";
        position: absolute;
        bottom: 100%;
        left: 67%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent #626262 transparent;
    }

    .line-nav-option {
        color: #292929;
        user-select: none;
        text-decoration: unset;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
        transition: color 0.35s ease;
        font-size: 14px;
    }

    .line-nav-option:hover {
        color: #cf2c2f;
    }
</style>
